module.exports = __webpack_public_path__ + "img/aspiration-icon.56074811.png";